const Methods = [
  {
    label: "Scrum Metodiky",
    semester: "",
    data: "./documents/Methods/Metodika_scrum.pdf",
    date: "04.10.2021",
    
    
  },
  {
    label: "SQL Metodika",
    semester: "",
    data: "./documents/Methods/Metodika_SQL.pdf",
    date: "29.10.2021",
    
    
  },
  {
    label: "Code Reviews Metodika",
    semester: "",
    data: "./documents/Methods/Metodika_Code_Reviews.pdf",
    date: "08.10.2021",
    
    
  },
  {
    label: "Git Metodika",
    semester: "",
    data: "./documents/Methods/Metodika_Git.pdf",
    date: "08.10.2021",
    
    
  },
  {
    label: "Metodika Dokumentov",
    semester: "",
    data: "./documents/Methods/Metodika_Dokumentov.pdf",
    date: "08.10.2021",
    
    
  },
  {
    label: "Definition Of Done",
    semester: "",
    data: "./documents/Methods/Definition_Of_Done.pdf",
    date: "11.10.2021",
    
    
  },
  {
    label: "Definition Of Ready",
    semester: "",
    data: "./documents/Methods/Definition_Of_Ready.pdf",
    date: "11.10.2021",
    
    
  },
]

export default Methods;
